// Single source of truth for downloadable export formats. The worker's zod
// enum (workers/src/index.ts export route) and the container dispatch must
// accept every value listed here.

export type ExportFormat = 'csv' | 'xlsx' | 'json' | 'qbo' | 'ofx'

export const EXPORT_FORMATS: { format: ExportFormat; label: string; hint: string }[] = [
  { format: 'csv', label: 'CSV', hint: 'Excel, Google Sheets, QuickBooks Online' },
  { format: 'xlsx', label: 'Excel', hint: 'XLSX workbook' },
  { format: 'json', label: 'JSON', hint: 'APIs and scripts' },
  { format: 'qbo', label: 'QBO', hint: 'QuickBooks Desktop (Web Connect)' },
  { format: 'ofx', label: 'OFX', hint: 'Xero, GnuCash, Money apps' },
]
